











































import { Component, Prop, Vue } from "vue-property-decorator";
import { passwordRules, emailRules } from "@/utils/validation";
import { inject } from "inversify-props";
import {
  IAuthService,
  ICenterService,
  IDoctorService,
  IPatientService
} from "@/interfaces/Services";
import {
  auth,
  doctor as doctorStore,
  patient as patientStore,
  center as centerStore
} from "@/store/modules";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({})
export default class LoginCard extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;
  @inject(DependencyIdentifiers.DoctorService)
  private doctorService!: IDoctorService;
  @inject(DependencyIdentifiers.CenterService)
  private centerService!: ICenterService;
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  @Prop(String) nextUrl : string | undefined;

  private isLoading = false;
  private hasErrored = false;
  private formData = {
    email: "",
    password: ""
  };

  private visibility = { password: false }
  private get formConfig() {
    return {
      email: {
        label: this.$t('account.email'),
        rules: [(v: string | undefined) => !!v || this.$t('validator.required'), ...emailRules]
      },
      password: {
        label: this.$t('account.password'),
        value: "",
        rules: [(v: string | undefined) => !!v || this.$t('validator.required')],
      }
    }
  };

  async submit() {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    this.isLoading = true;
    this.hasErrored = false;
    await this.authService
      .authenticate(this.formData)
      .then(async (token) => {
        auth.setAuthenticated(token);
        await this.authService.cacheMetadata();
        if (auth.isDoctor && !auth.hasExportLock) {
          this.$router.replace(this.nextUrl || "/dashboard/patients");
        } else if (auth.isDoctor && auth.hasExportLock) {
          this.$router.replace(this.nextUrl || "/dashboard/export/events");
        } else if (auth.isPatient) {
          this.$router.replace(this.nextUrl || "/dashboard/profile");
        }
      })
      .catch(err => {
        this.hasErrored = true;
        console.error("error", err);
      })
      .then(() => (this.isLoading = false));
  }
}
